import { HeaderNavItemTitle } from "elseware-ui";

function CustomHeaderNavItemTitle({ ...rest }) {
  return (
    <HeaderNavItemTitle
      styles="text-gray-400"
      {...rest}
    />
  );
}

export default CustomHeaderNavItemTitle;
